import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LuArrowRight, LuX } from 'react-icons/lu';

const DISMISSED_KEY = 'tl_sticky_cta_dismissed';

export default function StickyBottomCta() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try { if (sessionStorage.getItem(DISMISSED_KEY)) setDismissed(true); } catch {}
  }, []);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => {
    setDismissed(true);
    try { sessionStorage.setItem(DISMISSED_KEY, '1'); } catch {}
  };

  if (dismissed) return null;

  return (
    <div className={`tlsc${visible ? ' tlsc--visible' : ''}`} role="complementary" aria-label="Try TextLink">
      <div className="tlsc-pill">
        <span className="tlsc-badge">
          <span className="tlsc-badge-dot" />
          Limited
        </span>
        <div className="tlsc-copy">
          <p className="tlsc-line">
            <strong>300&nbsp;free&nbsp;SMS</strong>
            <span className="tlsc-sep">·</span>
            <span className="tlsc-muted">to get started</span>
          </p>
        </div>
        <Link to="/signup" className="tlsc-cta">
          Claim
          <LuArrowRight size={15} strokeWidth={2} className="tlsc-arrow" />
        </Link>
        <button onClick={close} className="tlsc-close" aria-label="Dismiss">
          <LuX size={14} strokeWidth={2} />
        </button>
      </div>

      <style jsx>{`
        .tlsc {
          position: fixed;
          left: 50%;
          bottom: clamp(1rem, 2.5vh, 1.5rem);
          transform: translate(-50%, calc(100% + 2rem));
          z-index: 999;
          opacity: 0;
          transition:
            transform 520ms cubic-bezier(0.16, 1, 0.3, 1),
            opacity 320ms ease;
          pointer-events: none;
          width: calc(100% - 2rem);
          max-width: 560px;
          font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
        .tlsc--visible {
          transform: translate(-50%, 0);
          opacity: 1;
          pointer-events: auto;
        }

        .tlsc-pill {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          background: #0a0a0a;
          border: 1px solid rgba(255,255,255,0.08);
          color: #fff;
          padding: 0.5rem 0.5rem 0.5rem 1rem;
          border-radius: 999px;
          box-shadow:
            0 24px 48px -16px rgba(76, 29, 149, 0.35),
            0 8px 24px -8px rgba(0,0,0,0.4);
        }

        .tlsc-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.375rem;
          font-size: 0.6875rem;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #c4b5fd;
          flex-shrink: 0;
        }
        .tlsc-badge-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #a855f7;
          box-shadow: 0 0 10px #a855f7;
          animation: tlsc-blink 1.6s ease-in-out infinite;
        }
        @keyframes tlsc-blink {
          0%, 100% { opacity: 1; }
          50%      { opacity: 0.4; }
        }

        .tlsc-copy { flex: 1; min-width: 0; }
        .tlsc-line {
          margin: 0;
          font-size: 0.875rem;
          color: rgba(255,255,255,0.85);
          font-weight: 400;
          letter-spacing: -0.005em;
          display: inline-flex;
          align-items: baseline;
          gap: 0.5rem;
          flex-wrap: nowrap;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .tlsc-line strong {
          color: #fff;
          font-weight: 600;
        }
        .tlsc-sep { color: rgba(255,255,255,0.3); }
        .tlsc-muted { color: rgba(255,255,255,0.58); }

        .tlsc-cta {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          background: #ffffff;
          color: #0a0a0a !important;
          padding: 0.5rem 0.9rem;
          border-radius: 999px;
          font-size: 0.8125rem;
          font-weight: 500;
          text-decoration: none !important;
          letter-spacing: -0.005em;
          transition: background 160ms ease, transform 120ms ease;
          flex-shrink: 0;
        }
        .tlsc-cta:hover {
          background: #f4f4f5;
          color: #0a0a0a !important;
          transform: translateY(-1px);
          text-decoration: none !important;
        }
        .tlsc-arrow { transition: transform 180ms ease; }
        .tlsc-cta:hover .tlsc-arrow { transform: translateX(2px); }

        .tlsc-close {
          background: transparent;
          color: rgba(255,255,255,0.5);
          border: none;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-shrink: 0;
          transition: background 140ms ease, color 140ms ease;
        }
        .tlsc-close:hover {
          background: rgba(255,255,255,0.08);
          color: #fff;
        }

        @media (max-width: 520px) {
          .tlsc-muted, .tlsc-sep { display: none; }
          .tlsc-pill { padding-left: 0.875rem; gap: 0.5rem; }
          .tlsc-badge { display: none; }
          .tlsc-line { font-size: 0.8125rem; }
          .tlsc-cta { padding: 0.5rem 0.75rem; font-size: 0.75rem; }
        }
      `}</style>
    </div>
  );
}
